<template>
  <div
    :class="showFold ? '' : 'inactive'"
    class="rightBox"
    :style="{ background: swiechColor }"
  >
    <div @click="foldClick" class="fold-div">
      <i :class="showFold ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"> </i>
      <span>{{ showFold ? "收起" : "展开" }}</span>
    </div>
    <RightItem01
      v-show="showFold"
      class="rightItem01Box"
      :rightObj="rightObj.rightItem01Obj"
      style="height: 26%; margin-bottom: 2%"
      @childNumberClick="$emit('childNumberClick', $event)"
    />
    <RightItem02
      v-show="showFold"
      class="rightItem02Box"
      :rightObj="rightObj.rightItem02Obj"
      style="height: 38%; margin-bottom: 2%"
    />
    <RightItem03
      v-show="showFold"
      class="rightItem03Box"
      :rightObj="rightObj.rightItem03Obj"
      style="height: 33%"
    />
  </div>
</template>

<script>
import RightItem01 from "./rightItem01.vue";
import RightItem02 from "./rightItem02.vue";
import RightItem03 from "./rightItem03.vue";
export default {
  props: {
    swiechColor: {
      typeof: String,
    },
    rightObj: {
      typeof: Object,
    },
  },
  components: {
    RightItem01,
    RightItem02,
    RightItem03,
  },
  data() {
    return {
      showFold: true,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$bus.$on("foldClick-right", (show) => {
      this.showFold = show;
    });
  },
  methods: {
    foldClick() {
      this.showFold = !this.showFold;
    },
  },
};
</script>

<style lang="scss" scoped>
.inactive {
  width: 100px !important;
  overflow: hidden;

  .fold-div {
    right: 40px !important;
  }
}
.rightBox {
  width: 24%;
  height: 88%;
  color: #fff;
  position: relative;
  .fold-div {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 16px;
    cursor: pointer;
  }
  .rightItem01Box,
  .rightItem02Box,
  .rightItem03Box {
    padding-top: 0.5vh;
    background: url("../../../assets/dataScreen/leftBorder.png") no-repeat; // no-repeat top center / cover
    background-size: 100% 100%;
    background-color: rgba(9, 21, 42, 0.8);
    border-radius: 4px;
  }
}
</style>
